import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, homeForRole } from "@/context/AuthContext";
import { Loading } from "@/components/kit";

export default function RequireAuth({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen bg-black"><Loading /></div>;
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homeForRole(user.role)} replace />;
  }
  return children;
}
